export const initialState = {
	dashboard: {},
	events: {
		items: [],
		page: 0,
	},
	store: {
		items: [],
		page: 0,
	},
	requests: {
		items: [],
		page: 0,
	},
	profile: {
		admin: false,
		store_admin: false,
		self_balance: 0,
		distrib_balance: 0,
	},
};
